module.exports = __webpack_public_path__ + "static/media/student-plan-img.3dbba301.jpeg";